import XPReport from '@xpeng/gio-report'
import pkg from '../package.json'

function getClientEnv() {
  const host = window.location.host
  if (host.includes('deploy-test.xiaopeng.com')) {
    return 'uat'
  }
  
  if (host.includes('yhtdbx')) {
    return 'production'
  }
  return 'dev'
}

let reportInstance = null

/**
 * 埋点上报
 * @param mcode 日志类型代码
 * @param type 类型： 页面曝光-page， 页面元素曝光-element， 事件-event
 * @param params
 */
export function sendDataTrack(
  mcode,
  type = 'event',
  params
) {
  if (!reportInstance) {
    const env = getClientEnv()
    const options = env === 'production' ? {
      accountId: '84eafaa69d23412f',
      dataSourceId: 'b68df2e1b04a1bcb',
      host: 'collect.xiaopeng.com'
    } : {
      accountId: '89a922449121f7c2',
      dataSourceId: 'aa1d26be2a6731b3',
      host: 'collect.test.xiaopeng.com'
    }
    Object.assign(options, {
      env,
      autotrack: false,
      compress: env === 'production',
      version: pkg.version,
      debug: env !== 'production'
    })
    reportInstance = new XPReport({
      appid: 'J001',
      so: 'J001013'
    }, options)
  }
  const sendParams = {
    eventId: 'Web_Insurance_Event',
    mcode,
    type
  }
  params && Object.assign(sendParams, params)
  reportInstance.send(sendParams)
}